export default __webpack_public_path__ + "static/media/Gilroy-Medium.1b4da658.ttf";